import { setRange } from './helpers';

export const setBeds = setRange('beds_count');
